const arrayHasEmptyValues = (array) => {
	const isNotEmpty = (value) => value !== '';
	return !array.every(isNotEmpty);
};

export default arrayHasEmptyValues;
